<div  class="continer-width text-center m-2 d-flex ">
        <h6 class="d-flex align-items-center ml-2 trade">2024 © PCS Management Consultancy Pvt. Ltd. All rights reserved.</h6>  <h6 class="d-flex align-items-center"><marquee class=" marquee-text-color">
            For immediate assistance, please don't hesitate to reach out to our dedicated support team at 9918000241
       </marquee></h6>
  </div>